import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { implementationPrivateRoutesConstants } from "./routesConstants";

const ImplementationPage = lazy(() => import("../../pages/Implementation"));

const ImplementationPrivateRoutes = () => {
  return (
    <Switch>
      <Route path={implementationPrivateRoutesConstants.root.path} exact>
        <ImplementationPage />
      </Route>
    </Switch>
  );
};

export default ImplementationPrivateRoutes;
